import { z } from 'zod';
import { emailSchema, merchantSlugSchema, optionalMoneySchema, passwordSchema, phoneSchema, } from './common.js';
export const registerSchema = z
    .object({
    name: z.string().trim().min(2, 'Enter your full name').max(120),
    email: emailSchema,
    password: passwordSchema,
    confirmPassword: z.string(),
    /** Store name chosen at signup; the slug is derived and confirmed later. */
    businessName: z.string().trim().min(2, 'Enter your business name').max(160),
    phone: phoneSchema.optional(),
    acceptTerms: z.literal(true, {
        errorMap: () => ({ message: 'You must accept the terms to continue' }),
    }),
})
    .refine((v) => v.password === v.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
});
export const loginSchema = z.object({
    email: emailSchema,
    password: z.string().min(1, 'Enter your password').max(128),
    rememberMe: z.boolean().default(false),
});
export const forgotPasswordSchema = z.object({
    email: emailSchema,
});
export const resetPasswordSchema = z
    .object({
    token: z.string().min(16, 'This reset link is invalid').max(256),
    password: passwordSchema,
    confirmPassword: z.string(),
})
    .refine((v) => v.password === v.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
});
export const verifyEmailSchema = z.object({
    token: z.string().min(16).max(256),
});
export const resendVerificationSchema = z.object({
    email: emailSchema,
});
export const changePasswordSchema = z
    .object({
    currentPassword: z.string().min(1, 'Enter your current password'),
    password: passwordSchema,
    confirmPassword: z.string(),
})
    .refine((v) => v.password === v.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
});
/** Onboarding step payloads. Each step is persisted independently so the
 *  wizard can resume exactly where the merchant left off. */
export const onboardingBusinessInfoSchema = z.object({
    businessName: z.string().trim().min(2).max(160),
    /** SSM registration number, optional for sole proprietors not yet registered. */
    registrationNumber: z.string().trim().max(50).nullable().optional(),
    phone: phoneSchema,
    addressLine1: z.string().trim().min(1).max(200),
    addressLine2: z.string().trim().max(200).nullable().optional(),
    city: z.string().trim().min(1).max(100),
    state: z.string().trim().min(2).max(60),
    postcode: z.string().trim().regex(/^\d{5}$/, 'Enter a valid 5-digit postcode'),
});
export const onboardingStoreDetailsSchema = z.object({
    storeName: z.string().trim().min(2).max(120),
    slug: merchantSlugSchema,
    currency: z.literal('MYR').default('MYR'),
    timezone: z.string().trim().min(3).max(64).default('Asia/Kuala_Lumpur'),
    supportEmail: emailSchema.optional(),
});
export const onboardingPaymentSetupSchema = z.object({
    /** Phase 1 offers the sandbox provider only. */
    provider: z.literal('mock'),
    displayName: z.string().trim().min(2).max(80).default('Sandbox payments'),
});
export const onboardingShippingSetupSchema = z.object({
    zoneName: z.string().trim().min(2).max(80).default('West Malaysia'),
    methodName: z.string().trim().min(2).max(80).default('Standard delivery'),
    rate: z.string().regex(/^\d+(\.\d{1,2})?$/, 'Enter a valid rate'),
    freeShippingThreshold: optionalMoneySchema,
});
//# sourceMappingURL=auth.js.map